/*
 * Calm, premium page-enter transition: a soft fade with a slight upward drift.
 * Uses only `opacity` + `transform` (compositor-friendly, no layout reflow).
 */
.page {
  /* Fill the height the page had before wrapping, so `h-full` / centered layouts keep working and
     tall pages still scroll on the parent (no layout jump). */
  display: flex;
  flex-direction: column;
  min-height: 100%;
  animation: page-enter 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* Let the single page root grow to fill (preserves vertical centering) without squashing content. */
.page > * {
  flex: 1 0 auto;
}

@keyframes page-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

/* Accessibility: honor the user's reduced-motion preference — no movement, no fade-in delay. */
@media (prefers-reduced-motion: reduce) {
  .page {
    animation: none;
  }
}
